// extracted by mini-css-extract-plugin
module.exports = {"popUp":"PopUp2_popUp__5TGao"};